import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrderDetailsCard = ({ order }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date?.getFullYear()}년 ${date?.getMonth() + 1}월 ${date?.getDate()}일`;
  };

  const formatPrice = (price) => {
    return `${price?.toLocaleString('ko-KR')}원`;
  };

  return (
    <div className="w-full rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl sm:p-8">
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h3 className="text-xl font-bold text-foreground">주문 상세</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            주문번호: {order?.orderNumber}
          </p>
        </div>
        <div className="rounded-full bg-primary/10 px-3 py-1">
          <p className="text-sm font-medium text-primary">{order?.statusLabel}</p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Customer Information */}
        <div className="rounded-lg border border-border p-4">
          <h4 className="mb-3 flex items-center text-sm font-semibold text-foreground">
            <Icon name="User" size={18} className="mr-2" />
            고객 정보
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">이름</span>
              <span className="font-medium text-foreground">{order?.customerName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">전화번호</span>
              <span className="font-medium text-foreground">{order?.phoneNumber}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">주소</span>
              <span className="font-medium text-right text-foreground">{order?.address}</span>
            </div>
          </div>
        </div>

        {/* Items Information */}
        <div className="rounded-lg border border-border p-4">
          <h4 className="mb-3 flex items-center text-sm font-semibold text-foreground">
            <Icon name="Package" size={18} className="mr-2" />
            세탁 품목
          </h4>
          <div className="space-y-3">
            {order?.items?.map((item, index) => (
              <div key={index} className="flex items-start justify-between border-b border-border pb-3 last:border-0 last:pb-0">
                <div className="flex-1">
                  <p className="font-medium text-foreground">{item?.brand} {item?.model}</p>
                  <p className="mt-1 text-xs text-muted-foreground">{item?.color}</p>
                  <p className="mt-1 text-xs text-primary">{item?.serviceType}</p>
                </div>
                <p className="font-semibold text-foreground">{formatPrice(item?.price)}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Pickup Information */}
        <div className="rounded-lg border border-border p-4">
          <h4 className="mb-3 flex items-center text-sm font-semibold text-foreground">
            <Icon name="MapPin" size={18} className="mr-2" />
            픽업 정보
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">픽업 방법</span>
              <span className="font-medium text-foreground">{order?.pickupType}</span>
            </div>
            {order?.pickupInstructions && (
              <div className="mt-2 rounded bg-muted/50 p-2">
                <p className="text-xs text-muted-foreground">요청사항</p>
                <p className="mt-1 text-sm text-foreground">{order?.pickupInstructions}</p>
              </div>
            )}
          </div>
        </div>

        {/* Dates Information */}
        <div className="rounded-lg border border-border p-4">
          <h4 className="mb-3 flex items-center text-sm font-semibold text-foreground">
            <Icon name="Calendar" size={18} className="mr-2" />
            일정 정보
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">주문일</span>
              <span className="font-medium text-foreground">{formatDate(order?.orderDate)}</span>
            </div>
            {order?.estimatedCompletion && (
              <div className="flex justify-between">
                <span className="text-muted-foreground">완료 예정일</span>
                <span className="font-medium text-foreground">{formatDate(order?.estimatedCompletion)}</span>
              </div>
            )}
          </div>
        </div>

        {/* Total Amount */}
        <div className="rounded-lg bg-primary/5 p-4">
          <div className="flex items-center justify-between">
            <span className="text-lg font-semibold text-foreground">총 결제금액</span>
            <span className="text-2xl font-bold text-primary">{formatPrice(order?.totalAmount)}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 sm:flex-row">
          {order?.currentStatus !== 'completed' && (
            <Button
              variant="secondary"
              fullWidth
              iconName="MessageCircle"
              iconPosition="left"
            >
              카카오톡 문의
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsCard;